import { LOGS as ECP_LOGS, } from '@exodus/exchange-client-providers';
import { sanitizeErrorMessage } from '@exodus/errors';
import { ExchangeError } from '@exodus/exchange-client-providers';
import { LOGS as EXCHANGE_LOGS } from './constants.js';
const LOGS = Object.freeze({ ...ECP_LOGS, ...EXCHANGE_LOGS });
export class ExchangeTracerModule {
    #messages = [];
    #timesById = new Map();
    #logger;
    timeLogs = new Map();
    constructor({ logger }) {
        this.#logger = logger;
    }
    traceMessage(message) {
        const logs = Object.values(LOGS);
        if (!logs.includes(message)) {
            this.#logger.warn(`Unknown message: ${message}`);
            return;
        }
        this.#messages.push(sanitizeErrorMessage(message));
    }
    traceError(error) {
        const message = error instanceof ExchangeError ? `${error.message}\nCLIENT_ERROR` : 'CLIENT_ERROR';
        this.#messages.push(sanitizeErrorMessage(message));
        this.#logger.error(message);
    }
    traceTime(id) {
        if (this.#timesById.has(id)) {
            this.#logger.warn(`Time tracer with id ${id} already started`);
            return;
        }
        const start = Date.now();
        this.#timesById.set(id, start);
    }
    traceTimeEnd(id) {
        const start = this.#timesById.get(id);
        if (!start) {
            this.#logger.warn(`Time tracer with id ${id} not started`);
            return;
        }
        const end = Date.now();
        const duration = end - start;
        this.timeLogs.set(id, duration);
        this.#timesById.delete(id);
    }
    clear() {
        this.#messages = [];
        this.timeLogs.clear();
        this.#timesById.clear();
    }
    print() {
        return this.#messages.join('\n');
    }
}
const exchangeTracerModuleFactory = (args) => new ExchangeTracerModule({ ...args });
const exchangeTracerModuleDefinition = {
    id: 'exchangeTracer',
    type: 'module',
    factory: exchangeTracerModuleFactory,
    dependencies: ['logger'],
};
export default exchangeTracerModuleDefinition;
